import PropTypes from 'prop-types';
import { ALIGN, SIZES, TYPES } from './constants';
import { iconsList } from '../icon/glyphs';

export const InputGroupProps = {
  id: PropTypes.string,
  size: PropTypes.oneOf(Object.keys(SIZES)),
  align: PropTypes.oneOf(Object.keys(ALIGN)),
  disabled: PropTypes.bool,
  value: PropTypes.string,
  defaultValue: PropTypes.string,
  placeholder: PropTypes.string,
  iconGlyph: PropTypes.oneOf(iconsList),
  prefixText: PropTypes.string,
  type: PropTypes.oneOf(Object.values(TYPES)),
  invalid: PropTypes.bool,
  selectOnFocus: PropTypes.bool,
  iconButtonGlyph: PropTypes.string,
  onIconButtonClick: PropTypes.func,
};
